import { connect } from 'react-redux';
import { requestChanges } from '../../../../../redux/mockup-manager/mockup-manager.actions';
import { NotecardMobileMessage as NotecardMobileMessageComponent } from './notecard-mobile-message';
const mapDispatchToProps = dispatch => ({
  onBack: () => {
    dispatch(requestChanges(false));
  }
});
export const NotecardMobileMessage = connect(null, mapDispatchToProps)(NotecardMobileMessageComponent);